import axiosInstance from './axiosInstance';

const submitEndpoint = "/neb/report/submt2"; // submit report
const submissionListEndpoint = "/neb/report/submissionList" //get all reports quarters and statuses
const submissionListAgencyEndpoint = "/neb/report/submissionListAgency"; //get reports by agency id
const getAllReportsEndpoint = "/neb/report/getAll"; // get all documents in the collection
const getReportByIdEndpoint = "/neb/report/getReportById"; // get report by report id
const updateReportEndpoint = "/neb/report/updateReport"; // update report
const deleteReportEndpoint = "/neb/report/deleteReport"; // delete report by report id
const getDTAResultEndpoint = "/neb/report/getProductStats"; // data trend analysis
const getDTADashboardResultEndpoint = "/neb/report/getReportTrendAnalysis"; // data trend analysis on admin dashboard
const getDistinctYearsEndpoint = "/neb/report/getDistinctYears"; // get distinct years from the collection

export const getSubmissionListAgency = async (agencyId) => {
    try {
        const response = await axiosInstance.get(`${submissionListAgencyEndpoint}/${agencyId}`);
        return response;
    } catch (error) {
        console.error('Error getting list:', error);
        throw error;
    }
};

export const getSubmissionList = async () => {
    try {
        const response = await axiosInstance.get(`${submissionListEndpoint}`);
        return response;
    } catch (error) {
        console.error('Error getting list:', error);
        throw error;
    }
};

export const getSubmissionListYear = async (year, quarter) => {
    try {
        const response = await axiosInstance.post(
            submissionListEndpoint,
            {
                year,
                quarter, // can be null or empty string
            }
        );
        return response;
    } catch (error) {
        console.error('Error getting list:', error);
        throw error;
    }
};

export const submitReport = async (reportData) => {
    try {
        const response = await axiosInstance.put(submitEndpoint, reportData);
        return response;
    } catch (error) {
        console.error('Error submitting report:', error);
        throw error;
    }
};

export const updateReport = async (reportId, reportData) => {
    try {
        const response = await axiosInstance.put(`${updateReportEndpoint}/${reportId}`, reportData);
        return response;
    } catch (error) {
        console.error('Error submitting report:', error);
        throw error;
    }
};

export const deleteReport = async (reportId) => {
    try {
        const response = await axiosInstance.delete(`${deleteReportEndpoint}/${reportId}`);
        return response;
    } catch (error) {
        console.error('Error deleting report:', error);
        throw error;
    }
};

export const getAllReport = async (agencyId) => {
    try {
        const response = await axiosInstance.get(`${getAllReportsEndpoint}/${agencyId}`);
        return response;
    } catch (error) {
        console.error('Error getting reports:', error);
        throw error;
    }
};

export const getReportById = async (id) => {
    try {
        const response = await axiosInstance.get(`${getReportByIdEndpoint}/${id}`);
        return response;
    } catch (error) {
        console.error('Error getting report:', error);
        throw error;
    }
};

export const getDTAResult = async (quarter, year, product, form, agencyId) => {
    try {
        const requestBody = {
            productName: product,
            quarter: quarter,
            currentYear: year,
            formCode: form,
            agencyId: agencyId
        };

        const response = await axiosInstance.post(getDTAResultEndpoint, requestBody);
        return response;
    } catch (error) {
        console.error('Error getting report:', error);
        throw error;
    }
};

export const getDashboardDTAResult = async (yearFrom, yearTo) => {
    try {
        const response = await axiosInstance.get(`${getDTADashboardResultEndpoint}/${yearFrom}/${yearTo}`);
        return response;
    } catch (error) {
        console.error('Error getting report:', error);
        throw error;
    }
};

export const getDistinctYears = async () => {
    try {
        const response = await axiosInstance.get(`${getDistinctYearsEndpoint}`);
        return response;
    } catch (error) {
        console.error('Error getting year list:', error);
        throw error;
    }
};

const getMissingSubmissionsEndpoint = "/neb/report/missing-submissions"; // endpoint to get not-submitted agencies

export const getMissingSubmissions = async (year, quarter, page = 1, pageSize = 10) => {
    try {
        const response = await axiosInstance.post(getMissingSubmissionsEndpoint, {
            year,
            quarter, // can be empty string for "All"
            page,
            pageSize
        });
        return response;
    } catch (error) {
        console.error("Error fetching missing submissions:", error);
        throw error;
    }
};

